import {
	View,
	Text,
	Image,
	SafeAreaView,
	TouchableOpacity,
	SectionList,
	ScrollView,
	ActivityIndicator,
} from "react-native";
import React, {
	useCallback,
	useEffect,
	useLayoutEffect,
	useState,
} from "react";
import { useFocusEffect, useNavigation } from "@react-navigation/native";
import { userData } from "../state/user";
import { jsonEval } from "@firebase/util";
import { db, getUserId } from "../utils/firebase";
import { doc, getDoc } from "firebase/firestore";
import { groupProblemsByDate } from "../utils/problemDate";
import { Difficulty, RequestedProblem } from "../types/Problem";
import { showDifficultyIt, showTopicIt } from "../utils/translation";
import { AntDesign, Entypo, Feather, Ionicons } from "@expo/vector-icons";

// function groupBy(xs, f) {
// 	return xs.reduce(function (rv, x) {
// 		(rv[f(x)] = rv[f(x)] || []).push({ problem: x, date: f(x) });
// 		return rv;
// 	}, {});
// }

function getDateString({
	year,
	month,
	day,
}: {
	year: number;
	month: number;
	day: number;
}) {
	let res = "";
	res += `${day.toString()} `;
	switch (month) {
		case 1:
			res += "Gennaio";
			break;
		case 2:
			res += "Febbraio";
			break;
		case 3:
			res += "Marzo";
			break;
		case 4:
			res += "Aprile";
			break;
		case 5:
			res += "Maggio";
			break;
		case 6:
			res += "Giugno";
			break;
		case 7:
			res += "Luglio";
			break;
		case 8:
			res += "Agosto";
			break;
		case 9:
			res += "Settembre";
			break;
		case 10:
			res += "Ottobre";
			break;
		case 11:
			res += "Novembre";
			break;
		case 12:
			res += "Dicembre";
			break;
		default:
			res += "";
	}
	res += " ";
	res += year.toString();
	return res;
}

const DifficultyColorText = ({ difficulty }: { difficulty: Difficulty }) => {
	switch (difficulty) {
		case "very-easy":
			return (
				<Text className="text-[#c3e88d]">
					{showDifficultyIt(difficulty)}
				</Text>
			);
		case "easy":
			return (
				<Text className="text-[#93b85d]">
					{showDifficultyIt(difficulty)}
				</Text>
			);
		case "medium":
			return (
				<Text className="text-[#f78c6c]">
					{showDifficultyIt(difficulty)}
				</Text>
			);
		case "hard":
			return (
				<Text className="text-[#f07178]">
					{showDifficultyIt(difficulty)}
				</Text>
			);
		case "very-hard":
			return (
				<Text className="text-[#ff5370]">
					{showDifficultyIt(difficulty)}
				</Text>
			);
		default:
			return (
				<Text className="text-[#ffffff]">
					{showDifficultyIt(difficulty)}
				</Text>
			);
	}
};

const Chronology = () => {
	const navigation = useNavigation();
	const [typology, setTypology] = useState("Geometria");

	useLayoutEffect(() => {
		navigation.setOptions({
			headerTitleAlign: "center",
			headerStyle: {
				backgroundColor: "#263238",
			},
			headerTitleStyle: {
				color: "white",
			},
			headerTintColor: "white",
			headerShadowVisible: false,
		});
	}, []);

	const [requestedProblems, setRequestedProblems] = useState([]);
	const [historyState, setHistoryState] = useState("loading"); // loading, loaded, zeroProblems, error

	useFocusEffect(
		useCallback(() => {
			setHistoryState("loading");
			if (userData.requested_problems !== null) {
				// const problems = Object.values(userData.requested_problems);
				if (Object.keys(userData.requested_problems).length === 0) {
					setHistoryState("zeroProblems");
				} else {
					const problems = [];
					for (const [id, problem] of Object.entries(
						userData.requested_problems
					)) {
						problems.push({
							id: id,
							...problem,
						});
					}
					const groupedProblems = groupProblemsByDate(problems);
					setRequestedProblems(groupedProblems);
					setHistoryState("loaded");
				}
			} else {
				async function getUserData() {
					const docRef = doc(db, "users", getUserId());
					const docSnap = await getDoc(docRef);

					if (docSnap.exists()) {
						const problems = [];
						userData.requested_problems =
							docSnap.data().requested_problems;
						if (
							Object.keys(docSnap.data().requested_problems)
								.length === 0
						) {
							setHistoryState("zeroProblems");
						} else {
							for (const [id, problem] of Object.entries(
								docSnap.data().requested_problems
							)) {
								problems.push({
									id: id,
									...problem,
								});
							}
							const groupedProblems =
								groupProblemsByDate(problems);
							// console.log(problems);
							// console.log(groupedProblems);
							setRequestedProblems(groupedProblems);
							setHistoryState("loaded");
						}
					} else {
						setRequestedProblems([]);
						setHistoryState("loaded");
					}
				}
				try {
					getUserData();
				} catch (error) {
					setHistoryState("error");
				}
			}
		}, [])
	);

	if (historyState === "error") {
		return (
			<SafeAreaView className="flex-1 bg-[#263238]">
				<View className="flex-1 px-2 justify-center w-full max-w-screen-lg mx-auto">
					<Text className="text-white text-xl text-center">
						Si è verificato un errore. Riprova.
					</Text>
				</View>
			</SafeAreaView>
		);
	}

	if (historyState === "zeroProblems") {
		return (
			<SafeAreaView className="flex-1 bg-[#263238]">
				<View className="flex-1 px-2 justify-center w-full max-w-screen-lg mx-auto">
					<Text className="text-white text-xl text-center">
						Comincia a risolvere problemi per vedere la cronologia!
					</Text>
				</View>
			</SafeAreaView>
		);
	}

	if (historyState === "loading") {
		return (
			<SafeAreaView className="flex-1 bg-[#263238]">
				<View className="flex-1 px-2 justify-center w-full max-w-screen-lg mx-auto">
					<View className="flex-1 items-center justify-center">
						<ActivityIndicator size={"large"} color="white" />
					</View>
				</View>
			</SafeAreaView>
		);
	}

	return (
		<SafeAreaView className="flex-1 bg-[#263238]">
			<View className="flex-1 px-2 justify-center w-full max-w-screen-lg mx-auto">
				<ScrollView className="flex-1 px-2">
					{requestedProblems.map((group, index) => {
						return (
							<View key={index} className="my-2">
								<Text className="text-white text-xl font-bold">
									{getDateString(group[0].last_submitted_at)}
								</Text>
								<View className="">
									{group.map((problem, index) => {
										return (
											<TouchableOpacity
												key={index}
												className="flex-row px-2 py-2 space-x-4 bg-[#1E272C] my-1 rounded-lg"
												onPress={() => {
													navigation.navigate(
														"ProblemById",
														{ id: problem.id }
													);
												}}
											>
												<Text className="text-white text-xl font-semibold self-center justify-self-center">
													{problem.last_submitted_at
														.hour < 10
														? "0" +
														  problem
																.last_submitted_at
																.hour
														: problem
																.last_submitted_at
																.hour}
													:
													{problem.last_submitted_at
														.minute < 10
														? "0" +
														  problem
																.last_submitted_at
																.minute
														: problem
																.last_submitted_at
																.minute}
												</Text>
												<View className="flex-1">
													{/* <Text className="text-white">
													{showDifficultyIt(
														problem.difficulty
													)}
												</Text> */}
													<DifficultyColorText
														difficulty={
															problem.difficulty
														}
													/>
													<Text className="text-white">
														{showTopicIt(
															problem.topic
														)}
													</Text>
												</View>
												{/* <Text className="text-white">
												Stato: {problem.status}
											</Text> */}
												{problem.status ===
												"correct" ? (
													<AntDesign
														name="check"
														size={24}
														color="green"
													/>
												) : problem.status ===
												  "wrong" ? (
													<Feather
														name="x"
														size={24}
														color="red"
													/>
												) : (
													<Ionicons
														name="arrow-redo"
														size={24}
														color="gray"
													/>
												)}
											</TouchableOpacity>
										);
									})}
								</View>
							</View>
						);
					})}
				</ScrollView>
			</View>
		</SafeAreaView>
	);
};

export default Chronology;

// import {
// 	View,
// 	Text,
// 	Image,
// 	SafeAreaView,
// 	TouchableOpacity,
// 	StyleSheet,
// } from "react-native";
// import React, { useLayoutEffect, useState } from "react";
// import { useNavigation } from "@react-navigation/native";
// import { Picker } from "@react-native-picker/picker";
// // import MyPicker from "../utils/WheelPicker";
// // import { Picker, DatePicker } from "react-native-wheel-pick";

// const Chronology = () => {
// 	const navigation = useNavigation();
// 	const [typology, setTypology] = useState("Qualsiasi");

// 	useLayoutEffect(() => {
// 		navigation.setOptions({
// 			headerTitleAlign: "center",
// 			headerStyle: {
// 				backgroundColor: "#263238",
// 			},
// 			headerTitleStyle: {
// 				color: "white",
// 			},
// 			headerTintColor: "white",
// 		});
// 	}, []);

// 	return (
// 		<SafeAreaView className="flex-1 bg-[#263238]">
// 			<View style={styles.container}>
// 				<Picker
// 					selectedValue={typology}
// 					style={{
// 						height: 50,
// 						width: 150,
// 						backgroundColor: "#1E272C",
// 						borderColor: "black",
// 						textDecorationColor: "white",
// 					}}
// 					onValueChange={(itemValue, itemIndex) =>
// 						setTypology(itemValue)
// 					}
// 				>
// 					<Picker.Item color="white" label="Java" value="java" />
// 					<Picker.Item color="white" label="JavaScript" value="js" />
// 				</Picker>
// 			</View>
// 			<View className="flex-1 justify-center items-center">
// 				<Text className="text-3xl text-white">Cronologia</Text>
// 			</View>
// 		</SafeAreaView>
// 	);
// };

// const styles = StyleSheet.create({
// 	container: {
// 		flex: 1,
// 		paddingTop: 40,
// 		alignItems: "center",
// 	},
// });

// export default Chronology;
